<!--
    Multiply Calculator Component
    Simple calculator that multiplies two numbers
-->
<svelte:options customElement={{ tag: "multiply-calculator", shadow: "none" }} />

<script lang="ts">
    let firstNumber: number = $state(1);
    let secondNumber: number = $state(1);
    let result: number = $derived(firstNumber * secondNumber);

    function handleFirstInput(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        firstNumber = parseFloat(value) || 0;
    }

    function handleSecondInput(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        secondNumber = parseFloat(value) || 0;
    }
</script>

<div class="multiply-calculator">
    <div class="field">
        <label class="label" for="multiply-first">First Number</label>
        <div class="control">
            <input id="multiply-first" class="input" type="number" value={firstNumber} oninput={handleFirstInput} placeholder="Enter first number" />
        </div>
    </div>

    <div class="field">
        <label class="label" for="multiply-second">Second Number</label>
        <div class="control">
            <input id="multiply-second" class="input" type="number" value={secondNumber} oninput={handleSecondInput} placeholder="Enter second number" />
        </div>
    </div>

    <div class="field">
        <label class="label">Result</label>
        <div class="control">
            <p class="title is-4">{firstNumber} × {secondNumber} = {result}</p>
        </div>
    </div>
</div>

<style>
    .multiply-calculator {
        max-width: 400px;
        margin: 0 auto;
    }
</style>
